<template>
  <div>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card v-can="'view-credit-note'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters"
          class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">General</label>
              <vs-input type="search" placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full" />
            </div>
            <div class="vx-col md:w-1/4 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">Status</label>
              <v-select v-model="filters['status']" :options="statusList" name="status" />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Date From</label>
              <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['from']"
                placeholder="Choose Date" />
              <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['from']"
                placeholder="Choose Date" />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Date To</label>
              <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['to']"
                placeholder="Choose Date" />
              <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['to']"
                placeholder="Choose Date" />
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                v-on:click="filters = {}">CLEAR</vs-button>
            </div>
          </div>
        </vx-card>
        <vx-card title="CREDIT NOTES">
          <template slot="actions">
            <div class="flex">
              <excel-download :name="'credit-note-sheet'"  :filters="filters"/>
            </div>
          </template>
          <div v-can="'view-credit-note'" slot="no-body" class="mt-4">

            <vs-table :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff" @sort="handleSort" :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="10%" sort-key="change_to">CREDIT NOTE CODE</vs-th>
                <vs-th width="10%">CUSTOMER</vs-th>
                <vs-th width="15%" sort-key="created_at">CREATED DATE & BY</vs-th>
                <!-- <vs-th width="10%" sort-key="created_by">CREATED BY</vs-th> -->
                <vs-th width="10%" >ORIGINAL CREDIT AMOUNT (EXCL VAT/TAX)</vs-th>
                <vs-th width="10%" >REMAINING CREDIT AMOUNT (EXCL VAT/TAX)</vs-th>
                <vs-th width="10%" >CREDIT USED (EXCL VAT/TAX)</vs-th>
                <vs-th width="5%" sort-key="status">STATUS</vs-th>
                <vs-th width="10%">ORIGINAL SO CN RAISED AGAINST</vs-th>
                <vs-th width="10%">SO CREDIT USED AGAINST</vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr
                  @click.native="onClickCustomerCreditNoteUpdate(data[indextr].id, data[indextr].customer.id, tr.customer.account_currency)"
                  style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].credit_note_code">
                    {{ data[indextr].credit_note_code }}
                  </vs-td>

                  <vs-td>
                    <a @click.stop="onClickViewCustomer(data[indextr].customer.id)">
                      {{ data[indextr].customer.company_name }}
                    </a>
                  </vs-td>

                  <vs-td :data="data[indextr].created_at">
                    {{ __dateTimeFormatterToDate(data[indextr].created_at) }} <br>
                    By {{ data[indextr].created_by_staff }}
                  </vs-td>

                  <!-- <vs-td :data="data[indextr].created_by_staff">
                    {{ data[indextr].created_by_staff }}
                  </vs-td> -->

                  <vs-td :data="data[indextr].credit_amount">
                    {{ currencySymbolGenerator(tr.customer.account_currency) }}
                    {{ Number(data[indextr].credit_amount).toFixed(2) }}
                  </vs-td>

                  <vs-td :data="data[indextr].remaining_credit_amount">
                    {{ currencySymbolGenerator(tr.customer.account_currency) }}
                    {{ Number(data[indextr].remaining_credit_amount).toFixed(2) }}
                  </vs-td>

                  <vs-td>
                    {{ currencySymbolGenerator(tr.customer.account_currency) }}
                    {{ Number(data[indextr].credit_amount) - Number(data[indextr].remaining_credit_amount) }}
                  </vs-td>

                  <vs-td :data="data[indextr].status">
                    <vs-chip transparent :color="data[indextr].status === 'Active' ? 'primary' : 'danger'">
                      {{ data[indextr].status }}
                    </vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].product_order_code">
                    <a @click.stop="onCLickViewProductOrder(data[indextr].belongs_to_product_order.id)"
                      class="text-primary cursor-pointer">
                      <vx-tooltip class="ml-2" :text="`View ${data[indextr].belongs_to_product_order.product_order_code}`"
                        position="top">
                        {{ data[indextr].belongs_to_product_order.product_order_code }}
                      </vx-tooltip>
                    </a>
                  </vs-td>

                  <vs-td>
                    <a v-if="tr.credit_note_used_by.length > 0" :key="index_so"
                      v-for="(so, index_so) in tr.credit_note_used_by" @click.stop="onCLickViewProductOrder(so.id)"
                      class="text-primary cursor-pointer">
                      <vx-tooltip class="ml-2" :text="`View ${so.product_order_code}`" position="top">
                        {{ so.product_order_code + ', ' }}
                      </vx-tooltip>
                    </a>
                    <span v-if="tr.credit_note_used_by.length === 0">N/A</span>
                  </vs-td>


                  <vs-td v-can="'create-edit-credit-note'">
                    <div class="vx-row">
                      <vx-tooltip class="ml-2" text="View/Update" position="top">
                        <vs-button
                          @click.stop="onClickCustomerCreditNoteUpdate(data[indextr].id, data[indextr].customer.id, tr.customer.account_currency)"
                          size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="ml-2" text="View Credit Note Email Logs" position="top">
                        <vs-button @click.stop="onClickViewCreditNoteEmailLogs(data[indextr].id)"
                                   size="small" color="danger" type="filled" icon-pack="feather" icon="icon-list"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of" description-title="Records"
              description :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0"
              v-model="page" class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>

    <update-credit-note-from-order-pop-up ref="updateCreditNoteFromOrderPopUp"/>
    <credit-note-email-log-pop-up ref="creditNoteEmailLogPopUp"/>

  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const CustomerRepository = RepositoryFactory.get('customer')
import UpdateCreditNoteFromOrderPopUp
  from "@/components/popups/customer/product-orders/credit-note/UpdateCreditNoteFromOrderPopUp";
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { defaultPagination, perPageList } from "@/constants/config";
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import CreditNoteEmailLogPopUp from "@/components/popups/customer/product-orders/credit-note/CreditNoteEmailLogPopUp";

export default {
  name: 'CreditNoteList',
  data() {
    return {
      staff: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      customers: [],
      staffs: [],
      account_currency: 'GBP',
      statusList: ['Active', 'Invalid', 'Used']
    }
  },
  components: {
    'v-select': vSelect,
    flatPickr,
    UpdateCreditNoteFromOrderPopUp,
    CreditNoteEmailLogPopUp
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  methods: {
    async refreshData() {
      this.fetchCreditNotes()
    },
    async fetchCreditNotes() {
      this.$vs.loading()
      try {
        const { data } = await CustomerRepository.getCreditNoteList(this.page, this.filterQuery, this.perPage, this.sort)
        this.staff = data.data
        this.meta = data.meta
      } catch (error) {
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    filterQueryUpdate() {
      this.fetchCreditNotes()
    },
    handleChangePage(page) {
      this.page = page;
      this.fetchCreditNotes()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchCreditNotes()
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    async onCLickViewProductOrder(id) {
      await this.$router.push({ path: `/pages/product-orders/${id}` })
    },
    async onClickCustomerCreditNoteUpdate(id, customer_id, account_currency) {
      this.account_currency = account_currency
      await this.$refs.updateCreditNoteFromOrderPopUp.openPopup(id, customer_id)
    },
    async onClickViewCustomer(id) {
      await this.$router.push({ path: `/pages/manage-nimble/customers/${id}` })
    },
    async onClickViewCreditNoteEmailLogs(id) {
      await this.$refs.creditNoteEmailLogPopUp.openPopup(id)
    },
    currencySymbolGenerator(currency) {
      return this.__currencySymbol(currency)
    }

  },
  watch: {
    page() {
      this.fetchCreditNotes()
    },
    perPage() {
      this.fetchCreditNotes()
    }
  },
}
</script>


<style scoped>
.user-edit-popup>>>.vs-popup {
  min-height: 50% !important;
  min-width: 50% !important;
}

@media (min-width: 768px) and (max-width: 1319px) {
  .user-edit-popup>>>.vs-popup {
    min-height: 50% !important;
    min-width: 65% !important;
  }
}
</style>
